
import React,{ useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CountUp from "react-countup";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from 'moment';
import { Pie } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PersonCircle } from 'react-bootstrap-icons';
import { faAngleDown, faAngleUp, faBriefcase, faBriefcaseClock, faClock, faTasks, faBars, faChartLine, faFlagUsa, faFolderOpen, faGlobeEurope, faPaperclip, faUserPlus, faListCheck } from '@fortawesome/free-solid-svg-icons';
import { faBed } from "@fortawesome/free-solid-svg-icons";
import { FaUser, FaUsers, FaDoorOpen } from "react-icons/fa";
import { Col, Row, Card, Image, Button, ListGroup, Modal, ProgressBar, Spinner, Badge, Dropdown } from '@themesberg/react-bootstrap';
//import { CircleChart, BarChart, SalesValueChart, SalesValueChartphone } from "./Charts";
import { BASE_URL } from "../constants";
import axios from "axios";
import Profile1 from "../assets/img/team/profile-picture-1.jpg";
import ProfileCover from "../assets/img/profile-cover.jpg";
import { useAuth } from "../Context/AuthContext";
import teamMembers from "../data/teamMembers";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);
export const ProfileCardWidget = () => {

  
  return (
    <Card border="light" className="text-center p-0 mb-4">
      <div style={{ backgroundImage: `url(${ProfileCover})` }} className="profile-cover rounded-top" />
      <Card.Body className="pb-5">
        <Card.Img src={Profile1} alt="Neil Portrait" className="user-avatar large-avatar rounded-circle mx-auto mt-n7 mb-4" />
        <Card.Title>Neil Sims</Card.Title>
        <Card.Subtitle className="fw-normal">Senior Software Engineer</Card.Subtitle>
        <Card.Text className="text-gray mb-4">New York, USA</Card.Text>

        <Button variant="primary" size="sm" className="me-2">
          <FontAwesomeIcon icon={faUserPlus} className="me-1" /> Connect
        </Button>
        <Button variant="secondary" size="sm">Send Message</Button>
      </Card.Body>
    </Card>
  );
};

export const ChoosePhotoWidget = ({ title, photo, onChange, preview }) => {
    return (
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          <h5 className="mb-4">{title}</h5>
          <div className="d-xl-flex align-items-center">
            <div className="user-avatar xl-avatar">
              <Image fluid rounded src={preview || photo} />
            </div>
            <div className="file-field">
              <div className="d-flex justify-content-xl-center ms-xl-3">
                <div className="d-flex">
                  <span className="icon icon-md">
                    <FontAwesomeIcon icon={faPaperclip} className="me-3" />
                  </span>
                  <input type="file" onChange={onChange} />
                  <div className="d-md-block text-start">
                    <div className="fw-normal text-dark mb-1">Choose Image</div>
                    <div className="text-gray small">JPG or PNG. Max size: 5MB</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  };




  export const CounterWidget = (props) => {
    const { icon, iconColor, category, title } = props;
    const [userCount, setUserCount] = useState(0);
    const [newUserPercentage, setNewUserPercentage] = useState(0);
    const [loading, setLoading] = useState(true); // Added loading state
    const [error, setError] = useState(null); // Added error state
    const { user } = useAuth();
    const shelterId = user.shelter.id;
 
    useEffect(() => {
      const fetchUsers = async () => {
        if (!user?.shelter?.id) return; 
  
        try {
          setLoading(true);
          setError(null); 
  
          const response = await axios.get(`${BASE_URL}/refugees/availability/${shelterId}`);
       
         const totalUsers = response.data.notAvailable.length;
  
          setUserCount(totalUsers);
      
        } catch (error) {
          console.error("Error fetching users data:", error);
          setError("Failed to fetch user data.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchUsers();
    }, [user]);
  
    const percentageIcon = newUserPercentage < 0 ? faAngleDown : faAngleUp;

  
    return (
      <Col className="mb-3 d-flex">
      <Card
        border="light"
        className="flex-fill shadow-sm"
        style={{
          background:  userCount > 0   
          ? "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)"
         : "linear-gradient(135deg, #6c757d 0%, #adb5bd 100%)", 
      
    borderRadius: "12px",
    color: "white",
    boxShadow: "0px 19px 60px rgb(0 0 0 / 8%)",
        }}
      >
        <Card.Body>
          <Row className="align-items-center">
            {/* Icon Section */}
            <Col xs={4} sm={4} className="text-center text-sm-start mb-3 mb-sm-0">
        <div
          className={`icon icon-shape icon-md icon-${iconColor} rounded`}
          style={{ display: "inline-block" }}
        >
          <FontAwesomeIcon
            icon={icon}
            style={{
              stroke: "white",
              strokeWidth: "12px",
              filter: "drop-shadow(1px 2px 3px rgba(255, 255, 255, 0.5))",
            }}
          />
        </div>
      </Col>
    
            {/* Text Section */}
            <Col xs={8} sm={8} className="text-center text-sm-start">
              <h2 className="fw-bold text-white mb-1">
                {loading ? "..." : userCount}
              </h2>
              <p className="m-0 text-white">{title}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
    
   
  
    );
  };





  export const OccupancyCard = () => {
    const { user } = useAuth();
    const shelterId = user?.shelter?.id;
  
    const [accommodation, setAccommodation] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const fetchShelterData = async () => {
        try {
          const response = await axios.get(`${BASE_URL}/shelters/${shelterId}`);
          if (response.data) setAccommodation(response.data);
        } catch (error) {
          console.error("Error fetching shelter data:", error);
        } finally {
          setLoading(false);
        }
      };
  
      if (shelterId) fetchShelterData();
    }, [shelterId]);
  
    if (loading)
      return (
        <Card border="light" className="shadow-sm rounded-4 border-0" style={{ maxWidth: "520px" }}>
          <Card.Body className="text-center">
            <Spinner animation="border" />
          </Card.Body>
        </Card>
      );
  
    if (!accommodation)
      return (
        <Card border="light" className="shadow-sm rounded-4 border-0" style={{ maxWidth: "520px" }}>
          <Card.Body className="text-center">
            <p>Failed to load shelter data.</p>
          </Card.Body>
        </Card>
      );
  
    const occupiedPlaces = accommodation.currentOccupants || 0;
    const totalCapacity = accommodation.capacity || 0;
    const occupancyPercentage = totalCapacity ? Math.round((occupiedPlaces / totalCapacity) * 100) : 0;
    const freePlaces = totalCapacity - occupiedPlaces;
    const stateCoverage = accommodation.stateCoverage || 0;
    const stateCoveredUsers = accommodation.stateCoveredUsers || 0;
  
  
    const chartData = {
      labels: [], 
      datasets: [
        {
          label: "Occupancy",
          data: totalCapacity === 0 ? [0, 1] : [occupiedPlaces, freePlaces],
          backgroundColor: ["#1F3F49", "#CED2CC"],
          borderWidth: 0,
          cutout: "58%", 
        },
        {
          label: "State Coverage",
          data: [stateCoverage, 100 - stateCoverage],
          backgroundColor: [stateCoverage > occupancyPercentage ? "#dc3545" : "#a3d977", "transparent"],
          borderWidth: 0,
          cutout: "65%", 
        },
      ],
    };
    
    const chartOptions = {
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (tooltipItem) => {
              const datasetIndex = tooltipItem.datasetIndex;
              const dataIndex = tooltipItem.dataIndex;
              
              if (datasetIndex === 0) {
                const labels = ["Occupied", "Free"];
                return `${labels[dataIndex]}: ${tooltipItem.raw}`;
              } else if (datasetIndex === 1) {
              
                if (dataIndex === 0) return `State Covered Users: ${stateCoveredUsers}`;
                return null; 
              }
            },
          },
          filter: (tooltipItem) => {
            
            return !(tooltipItem.datasetIndex === 1 && tooltipItem.dataIndex === 1);
          },
        },
      },
      hover: {
        mode: "nearest",
        onHover: (event, chartElement) => {
        
          if (chartElement.length) {
            const datasetIndex = chartElement[0].datasetIndex;
            const dataIndex = chartElement[0].index;
            event.native.target.style.cursor =
              datasetIndex === 1 && dataIndex === 1 ? "default" : "pointer";
          } else {
            event.native.target.style.cursor = "default";
          }
        },
      },
    };
    
    
    return (
      <Card border="light" className="shadow-sm rounded-4 border-0" style={{ maxWidth: "520px" }}>
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0" style={{ color: "#1F3F49", fontWeight: "700" }}>
              {accommodation.name}
            </h5>
          </div>
  
          <Row className="text-center mt-4">
            <Col xs={4}>
              <h5 className="mb-0">{totalCapacity}</h5>
              <small className="text-muted">Capacity</small>
            </Col>
            <Col xs={4}>
              <h5 className="mb-0">{occupiedPlaces}</h5>
              <small className="text-muted">Occupied</small>
            </Col>
            <Col xs={4}>
              <h5 className="mb-0">{freePlaces}</h5>
              <small className="text-muted">Free</small>
            </Col>
          </Row>
  
          <div
  className="my-4 mx-auto position-relative"
  style={{
    width: "180px",
    height: "180px",
    transition: "transform 0.3s ease",
  }}
  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
>
  <Doughnut data={chartData} options={chartOptions} />
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontWeight: "bold",
      color: "#1F3F49",
      fontSize: "20px",
      pointerEvents: "none", // ensures tooltip still works
    }}
  >
    {occupancyPercentage}%
  </div>
</div>

  
          <Row className="mt-3">
            <Col xs={4} className="text-center">
              <span style={{ display: "inline-block", width: 10, height: 10, backgroundColor: "#1F3F49", marginRight: 5, borderRadius: 2 }} />
              <small>
                Occupied<br />
                <strong>{occupancyPercentage}%</strong>
              </small>
            </Col>
  
            <Col xs={4} className="text-center">
              <span style={{ display: "inline-block", width: 10, height: 10, backgroundColor: "#CED2CC", marginRight: 5, borderRadius: 2 }} />
              <small>
                Free<br />
                <strong>{100 - occupancyPercentage}%</strong>
              </small>
            </Col>
  
            <Col xs={4} className="text-center">
              <span
                style={{
                  display: "inline-block",
                  width: 10,
                  height: 10,
                  backgroundColor: stateCoverage > occupancyPercentage ? "#dc3545" : "#a3d977",
                  marginRight: 5,
                  borderRadius: 2,
                }}
              />
              <small>
                State-Coverage<br />
                <strong>{stateCoverage}%</strong>
              </small>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };
  

  


export const BarChartWidget = (props) => {
  const { title, value, percentage,category,icon, iconColor, data = [] } = props;
  const labels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const series = data.map(d => d.value);
  const percentageIcon = percentage < 0 ? faAngleDown : faAngleUp;
  const percentageColor = percentage < 0 ? "text-danger" : "text-success";

  return (
    <Card border="light" className="shadow-sm">
    <Card.Body>
        <Row className="d-block d-xl-flex align-items-center">
          <Col xl={5} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
            <div className={`icon icon-shape icon-md icon-${iconColor} rounded me-4 me-sm-0`}>
              <FontAwesomeIcon icon={icon} />
            </div>
            <div className="d-sm-none">
              <h5>{category}</h5>
              <h3 className="mb-1">{title}</h3>
            </div>
          </Col>
          <Col xs={12} xl={7} className="px-xl-0">
            <div className="d-none d-sm-block">
              <h5>{category}</h5>
              <h3 className="mb-1">{value}</h3>
              <h3 className="mb-1">{title}</h3>
            </div>
            <div className="small mt-2">
              <FontAwesomeIcon icon={percentageIcon} className={`${percentageColor} me-1`} />
              <span className={`${percentageColor} fw-bold`}>{percentage}%</span> Since last month
            </div>
          </Col>
        </Row>

    </Card.Body>
  </Card>

  );
};
const fetchAdmins = async () => {
  try {
    const response = await fetch(`${BASE_URL}/users/admins`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    // Retrieve the connected user's data from localStorage
    const userData = JSON.parse(localStorage.getItem('userData'));
  
    if (userData && userData.id) {
      // Ensure IDs are properly compared
      const filteredAdmins = data.filter(admin => admin._id !== userData.id);
      return filteredAdmins;
    }
    return data;
  } catch (error) {
    console.error('Error fetching admin data:', error);
    return [];
  }
};


export const TeamMembersWidget = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const handleClickUser = () => {
      navigate('/admin/users'); 
  };
  const handleClickAdmin = (adminId) => {
    navigate(`/chat?adminId=${adminId}`);
  };
  
  // Fetch team members
  useEffect(() => {
    const getAdmins = async () => {
      const admins = await fetchAdmins();
      setTeamMembers(admins);
    };
    getAdmins();
  }, []);

  // Fetch all users when modal opens
  useEffect(() => {
    if (showModal) {
      const fetchUsers = async () => {
        try {
          const response = await axios.get(`${BASE_URL}/users`);
          setUsers(response.data); 
        } catch (error) {
          console.error("Error fetching users:", error);
        }
      };
      fetchUsers();
    }
  }, [showModal]);

  // Handle admin toggle
 const handleAddAdmin = async (userId) => {
  try {
    // Retrieve token from localStorage
    const token = localStorage.getItem("token");

    await axios.put(
      `${BASE_URL}/refugees/${userId}`,
      { isAdmin: true },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    // Update local state to reflect the change
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user._id === userId ? { ...user, isAdmin: true } : user
      )
    );

    // Optionally, refresh team members list
    const updatedAdmins = await fetchAdmins();
    setTeamMembers(updatedAdmins);
  } catch (error) {
    console.error("Error updating admin status:", error);
  }
};


  const TeamMember = ({ name, lastName,  statusKey, image, icon, btnText, onClick }) => {
    const status = {
      online: { color: "success", label: "Online" },
      inMeeting: { color: "warning", label: "In a meeting" },
      offline: { color: "danger", label: "Offline" }
    };
    const statusColor = status[statusKey] ? status[statusKey].color : "danger",
          statusLabel = status[statusKey] ? status[statusKey].label : "Offline";

    return (
      <ListGroup.Item className="px-0">
      <Row className="align-items-center">
        <Col className="col-auto">
        <div className="user-avatar">
            {image ? (
              <img
                src={image}
                className="rounded-circle"
                alt="User avatar"
                width={40}
                height={40}
              />
            ) : (
              <PersonCircle size={40} className="text-gray-500" />
            )}
          </div>
        </Col>
        <Col className="ms--2">
          <h4 className="h6 mb-0">
            <a href="#!">{name} {lastName}</a>
          </h4>
          <span className={`text-${statusColor}`}>● </span>
          <small>{statusLabel}</small>
        </Col>
        <Col className="col-auto">
          <Button variant="tertiary" size="sm" onClick={onClick}>
            <FontAwesomeIcon icon={icon} className="me-1" /> {btnText}
          </Button>
        </Col>
      </Row>
    </ListGroup.Item>
    );
  };

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header className="border-bottom border-light d-flex justify-content-between">
          <h5 className="mb-0">Admins </h5>
          <Button variant="primary" size="sm" onClick={handleClickUser}>
            Add Admin
          </Button> 
        </Card.Header>
        <Card.Body>
        <ListGroup className="list-group-flush list my--3">
  {teamMembers.map((tm) => (
    <TeamMember
      key={`team-member-${tm.id}`}
      name={tm.firstName}
      lastName={tm.lastName}
      statusKey={tm.statusKey}
      image={tm.profilePhoto}
      icon={faUserPlus}
      btnText="Connect"
      onClick={() => handleClickAdmin(tm._id)} 
    />
  ))}
</ListGroup>

        </Card.Body>
      </Card>

      {/* Add Admin Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>All Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <ListGroup>
  {users.map(user => (
    <ListGroup.Item 
      key={user.id} 
      className="d-flex justify-content-between align-items-center"
    >
      {/* Display the user's full name */}
      <span>{user.firstName} {user.lastName}</span>

      {/* Display "Make Admin" button only if the user is not an admin */}
      {!user.isAdmin && (
        <Button 
          variant="primary" 
          size="sm" 
          onClick={() => handleAddAdmin(user.id)}
        >
          Make Admin
        </Button>
      )}
    </ListGroup.Item>
  ))}
</ListGroup>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const CircleChartWidget = ({ title, icon, iconColor = "primary" }) => {
  const [pendingTasks, setPendingTasks] = useState(0);
  const [totalTasks, setTotalTasks] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { user } = useAuth();
  const shelterId = user?.shelter?.id;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${BASE_URL}/tasks/shelter/${shelterId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const tasks = response.data;
        const pendingCount = tasks.filter((task) => task.status === "Expired").length;
        const totalTasks = tasks.length;
        setPendingTasks(pendingCount);
        setTotalTasks(totalTasks);
      } catch (err) {
        setError("Failed to fetch tasks. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Col className="mb-3 d-flex">
    <Card
      border="light"
      className="flex-fill shadow-sm"
      style={{
    background: pendingTasks > 0
      ? "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)"
      : "linear-gradient(135deg, #6c757d 0%, #adb5bd 100%)",  
    borderRadius: "12px",
    color: "white",
    boxShadow: "0px 19px 60px rgb(0 0 0 / 8%)",
  }}
      
    >
      <Card.Body>
        <Row className="align-items-center">
          {/* Icon Section */}
          <Col xs={4} sm={4} className="text-center text-sm-start mb-3 mb-sm-0">
      <div
        className={`icon icon-shape icon-md icon-${iconColor} rounded`}
        style={{ display: "inline-block" }}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{
            stroke: "white",
            strokeWidth: "12px",
            filter: "drop-shadow(1px 2px 3px rgba(255, 255, 255, 0.5))",
          }}
        />
      </div>
    </Col>
  
          {/* Text Section */}
          <Col xs={8} sm={8} className="text-center text-sm-start">
            <h2 className="fw-bold text-white mb-1">{pendingTasks}</h2>
            <p className="m-0 text-white">{title}</p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>    
  );
};



export const TotalRoomsWidget = ({ title, icon, iconColor = "primary" }) => {
  const [totalRooms, setTotalRooms] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { user } = useAuth();
  const shelterId = user?.shelter?.id;

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${BASE_URL}/accommodation/shelter/${shelterId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const rooms = response.data.rooms;
        setTotalRooms(rooms.length);
      } catch (err) {
        setError("Failed to fetch rooms. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (shelterId) {
      fetchRooms();
    }
  }, [shelterId]);

  return (
    <Col className="mb-3 d-flex">
<Card
  border="light"
  className="flex-fill shadow-sm"
  style={{
    background: "linear-gradient(135deg, #6c757d 0%, #adb5bd 100%)", 
    borderRadius: "12px",
     color: "white",
    boxShadow: "0px 19px 60px rgb(0 0 0 / 8%)",
  }}
>


        <Card.Body>
          <Row className="align-items-center">
            {/* Icon Section */}
            <Col xs={4} sm={4} className="text-center text-sm-start mb-3 mb-sm-0">
              <div
                className={`icon icon-shape icon-md icon-${iconColor} rounded`}
                style={{ display: "inline-block" }}
              >
                <FontAwesomeIcon
                  icon={icon}
                  style={{
                    stroke: "white",
                    strokeWidth: "12px",
                    filter: "drop-shadow(1px 2px 3px rgba(255, 255, 255, 0.5))",
                  }}
                />
              </div>
            </Col>

            {/* Text Section */}
            <Col xs={8} sm={8} className="text-center text-sm-start">
              <h2 className="fw-bold text-white mb-1">
                {loading ? "..." : totalRooms}
              </h2>
              <p className="m-0 text-white">{title}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};


export const ProgressTrackWidget = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
 

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        if (!id) return;
  
        console.log("Fetching rooms for shelter ID:", id);
        const response = await axios.get(`${BASE_URL}/accommodation/shelter/${id}`);
        const fetchedRooms = response.data.rooms || [];
  
        // Check if all rooms are full
        const allRoomsFull = fetchedRooms.every(room => room.currentOccupants === room.capacity);
  
        if (allRoomsFull) {
          setRooms([]);  // Set rooms to an empty array
          return null;
        }
  
        // Sort rooms by freePlaces descending (most free first)
        fetchedRooms.sort((a, b) => b.freePlaces - a.freePlaces);
  
        setRooms(fetchedRooms);
      } catch (error) {
        console.error("Error fetching rooms data:", error);
        setError(error.response?.data?.message || "Error fetching rooms");
      } finally {
        setLoading(false);
      }
    };
  
    fetchRooms();
  }, [id]);
  
  



  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
   
        </div>
      </div>
    );
  }
  

  if (rooms.length === 0) {
    return (
      <div className="card mt-3">
        <div className="card-body">
          <p className="card-text">No rooms created in this shelter.</p>
        </div>
      </div>
    );
  }
  const getColor = (percentage) => {
    if (percentage < 30) return "primary";
    if (percentage < 60) return "warning";
    if (percentage > 60) return "success";
    return "danger";
  };
  const Progress = ({ percentage, last }) => {
    const color = getColor(percentage);
    return (
      <Row className={`align-items-center ${last ? "" : "mb-2"}`}>
        <Col>
          <div className="progress-wrapper">
          <div className="progress-info d-flex justify-content-end">
            <small className="fw-bold text-dark">
              <span>{percentage}%</span>
            </small>
          </div>
            <ProgressBar variant={color} now={percentage} min={0} max={100} />
          </div>
        </Col>
      </Row>
    );
  };

  return (
    <Card border="light" className="shadow-sm">
    <Card.Header className="border-bottom border-light">
      <h5 className="mb-0"> Room Capacity</h5>
    </Card.Header>
    <Card.Body className="overflow-auto" style={{ maxHeight: '500px' }}>
      {rooms.map((room, index) => {
        const percentage = ((room.capacity - room.freePlaces) / room.capacity) * 100;
        return (
          <Card key={room._id} className="mb-3 p-3 border-light shadow-sm">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-1">
                Room {room.roomNumber}
              </h6>
              <Badge bg={room.freePlaces === 0 ? "danger" : "success"}>
                {room.freePlaces === 0 ? "Full" : "Available"}
              </Badge>
            </div>
            <p className="text-muted small">
              <FaUsers className="me-1" /> Capacity: <strong>{room.capacity}</strong> | 
              <FaUser className="ms-2 me-1 text-success" /> Occupied: <strong>{room.capacity - room.freePlaces}</strong> | 
              <FaUser className="ms-2 me-1 text-danger" /> Free: <strong>{room.freePlaces}</strong>
            </p>
            {room.occupant.length > 0 && (
              <p className="mb-1">
                <strong>Occupants:</strong> {room.occupant.map(o => `${o.firstName} ${o.lastName}`).join(", ")}
              </p>
            )}
          <Progress
              key={room._id}
              title={`Room ${room.roomNumber}`}
              percentage={Math.round(percentage)}
              last={index === rooms.length - 1}
            />
          </Card>
        );
      })}
    </Card.Body>
  </Card>
  
  );
};



export const RankingWidget = () => {
  return (
    <Card border="light" className="shadow-sm">
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between border-bottom border-light pb-3">
          <div>
            <h6><FontAwesomeIcon icon={faGlobeEurope} className="icon icon-xs me-3" /> Global Rank</h6>
          </div>
          <div>
            <Card.Link href="#" className="text-primary fw-bold">
              #755 <FontAwesomeIcon icon={faChartLine} className="ms-2" />
            </Card.Link>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between border-bottom border-light py-3">
          <div>
            <h6 className="mb-0"><FontAwesomeIcon icon={faFlagUsa} className="icon icon-xs me-3" />Country Rank</h6>
            <div className="small card-stats">
              United States <FontAwesomeIcon icon={faAngleUp} className="icon icon-xs text-success ms-2" />
            </div>
          </div>
          <div>
            <Card.Link href="#top" className="text-primary fw-bold">
              #32 <FontAwesomeIcon icon={faChartLine} className="ms-2" />
            </Card.Link>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between pt-3">
          <div>
            <h6 className="mb-0"><FontAwesomeIcon icon={faFolderOpen} className="icon icon-xs me-3" />Category Rank</h6>
            <Card.Link href="#top" className="small card-stats">
              Travel &gt; Accomodation
            </Card.Link>
          </div>
          <div>
            <Card.Link href="#top" className="text-primary fw-bold">
              #16 <FontAwesomeIcon icon={faChartLine} className="ms-2" />
            </Card.Link>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export const SalesValueWidget = (props) => {
  const { title, value, percentage } = props;
  const percentageIcon = percentage < 0 ? faAngleDown : faAngleUp;
  const percentageColor = percentage < 0 ? "text-danger" : "text-success";

  return (
    <Card className="bg-secondary-alt shadow-sm">
      <Card.Header className="d-flex flex-row align-items-center flex-0">
        <div className="d-block">
          <h5 className="fw-normal mb-2">
            {title}
          </h5>
          <h3>${value}</h3>
          <small className="fw-bold mt-2">
            <span className="me-2">Yesterday</span>
            <FontAwesomeIcon icon={percentageIcon} className={`${percentageColor} me-1`} />
            <span className={percentageColor}>
              {percentage}%
            </span>
          </small>
        </div>
        <div className="d-flex ms-auto">
          <Button variant="secondary" size="sm" className="me-2">Month</Button>
          <Button variant="primary" size="sm" className="me-3">Week</Button>
        </div>
      </Card.Header>
      <Card.Body className="p-2">
       
      </Card.Body>
    </Card>
  );
};

export const SalesValueWidgetPhone = (props) => {
  const { title, value, percentage } = props;
  const percentageIcon = percentage < 0 ? faAngleDown : faAngleUp;
  const percentageColor = percentage < 0 ? "text-danger" : "text-success";

  return (
    <Card className="bg-secondary-alt shadow-sm">
      <Card.Header className="d-md-flex flex-row align-items-center flex-0">
        <div className="d-block mb-3 mb-md-0">
          <h5 className="fw-normal mb-2">
            {title}
          </h5>
          <h3>${value}</h3>
          <small className="fw-bold mt-2">
            <span className="me-2">Yesterday</span>
            <FontAwesomeIcon icon={percentageIcon} className={`${percentageColor} me-1`} />
            <span className={percentageColor}>
              {percentage}%
            </span>
          </small>
        </div>
        <div className="d-flex ms-auto">
          <Button variant="secondary" size="sm" className="me-2">Month</Button>
          <Button variant="primary" size="sm" className="me-3">Week</Button>
        </div>
      </Card.Header>
      <Card.Body className="p-2">
     
      </Card.Body>
    </Card>
  );
};

export const AcquisitionWidget = () => {
  const [jobs, setJobs] = useState([]);

  const token = localStorage.getItem('token');
  useEffect(() => {
    const fetchJobs = async () => {
    
      try {
        const response = await axios.get(`${BASE_URL}/job`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        setJobs(response.data);
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    };
    fetchJobs();
  }, [token]);

  return (
    <Card border="light" className="shadow-sm">
    <Card.Body >
      <h5>Job Details</h5>
      <p>Provides an overview of job metrics, such as total jobs, open positions, and closed positions.</p>

      {/* Total Jobs */}
      <div className="d-flex align-items-center justify-content-between border-bottom border-light pb-3">
        <div>
          <h6>
            <FontAwesomeIcon icon={faBriefcase} className="icon icon-xs me-3" />
            Total Jobs
          </h6>
        </div>
        <div>
          <h5 className="mb-0 text-primary">{jobs.length}</h5>
        </div>
      </div>

      {/* Full-Time Jobs */}
      <div className="d-flex align-items-center justify-content-between border-bottom border-light py-3">
        <div>
          <h6>
            <FontAwesomeIcon icon={faBriefcaseClock} className="icon icon-xs me-3" />
            Full-Time
          </h6>
        </div>
        <div>
          <h5 className="mb-0 text-primary">
            {jobs.filter((job) => job.type === "Full-Time").length}
          </h5>
        </div>
      </div>

      {/* Part-Time Jobs */}
      <div className="d-flex align-items-center justify-content-between pt-3">
        <div>
          <h6>
            <FontAwesomeIcon icon={faClock} className="icon icon-xs me-3" />
            Part-Time
          </h6>
        </div>
        <div>
          <h5 className="mb-0 text-primary">
            {jobs.filter((job) => job.type === "Part-Time").length}
          </h5>
        </div>
      </div>
    </Card.Body>
  </Card>
  
  
  
  
  );
};